import { FilterField } from "~/features/filter";
import { optionsStatus } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы курсов: дата актуальности, код, код в ИС,
 * название и статус. Значения хранятся в URL (ActualOn — строкой yyyy-MM-dd).
 */
export const coursesFilterFields = (t: Translate): FilterField[] => [
  {
    name: "ActualOn",
    type: "datePicker",
    label: t("cep.actual_date_on"),
    disableFutureDates: true,
  },
  {
    name: "code",
    type: "input",
    label: t("cep.code"),
  },
  {
    name: "codeIS",
    type: "input",
    label: t("cep.codeInIS"),
  },
  {
    name: "name",
    type: "input",
    label: t("cep.name"),
  },
  {
    name: "status",
    type: "select",
    label: t("cep.status"),
    options: optionsStatus,
  },
];
